"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.afterHookPlugin = void 0;
const transform = (ctx) => {
    return ctx;
};
exports.afterHookPlugin = {
    name: 'After Hook Plugin',
    type: 'after',
    version: '1.0.0',
    isLoaded: () => true,
    load: () => Promise.resolve(),
    track: transform,
    page: transform,
    identify: transform,
};
//# sourceMappingURL=afterHook.js.map